import { Body1 } from '@linearb/linui-common/typography';
import { lightColorPalette } from '@linearb/linui-common';

/**
 * EditYourUserProfile component displays a message reminding users that they can edit their user profile
 * @returns {JSX.Element} A styled informational message component.
 */
export const EditYourUserProfile = () => {
  return (
    <Body1 italic color={lightColorPalette.lbTextSubdued} paddingTop={0.8}>
      You can always edit your User Profile from the user avatar.
    </Body1>
  );
};
